export const uiToApi = {
  Bounced: 'bounce',
  Deferred: 'deferred',
  Delivered: 'delivered',
  Dropped: 'dropped',
  Opened: 'open',
  Processed: 'processed',
  Spamreport: 'spamreport',
  Unsubscribed: 'unsubscribe',
  Clicked: 'click'
};
export const apiToUi = {
  bounce: 'Bounced',
  deferred: 'Deferred',
  delivered: 'Delivered',
  dropped: 'Dropped',
  open: 'Opened',
  processed: 'Processed',
  spamreport: 'Spamreport',
  unsubscribed: 'Unsubscribe',
  click: 'Clicked'
};
